import type { PackMessageKey } from './pack.en'

/** Pack hall phone strings (Hindi), spread into hi.ts. The type forces every key. */
export const packHi: Record<PackMessageKey, string> = {
  'pack.devSeed': 'पैकिंग हॉल का डेमो डेटा लोड करें',
  'pack.home.section': 'पैकिंग हॉल',
  'pack.home.title': 'पैक लाइन',
  'pack.home.hint': 'पैक रन शुरू करें, भरें और तौलें, बंद करें',
  'pack.home.runs': 'पैक रन · {n}',
  'pack.home.none': 'कोई पैक रन तय नहीं',
  'pack.home.noneBody':
    'ऑफिस हर पैक रन एक बैच से तय करता है। नए देखने के लिए साइट सूची अपडेट करें।',
  'pack.home.closed': 'बंद रन',
  'pack.home.lotsHint': 'लॉट रिलीज़ होने तक पाउच हॉल में रहते हैं।',
  'pack.stage.planned': 'तय',
  'pack.stage.filling': 'भराई चालू',
  'pack.stage.closed': 'बंद',
  'pack.badge.batchHeld': 'बैच रोका गया',
  'pack.pouchesPlanned': '{n} पाउच तय',
  'pack.plannedLine': '{kg} · {n} पाउच तय',
  'pack.pouchesN': '{n} पाउच',
  'pack.pouchesLeft': 'हॉल में {n} बचे',
  'pack.cartons': '{full} × {per} + {partial}',
  'pack.packDate': 'पैक {date}',
  'pack.bestBefore': '{date} से पहले उपयोग करें',

  'pack.lotState.PACKING': 'पैकिंग चालू',
  'pack.lotState.WAITING': 'रिलीज़ का इंतज़ार',
  'pack.lotState.RELEASED': 'रिलीज़',
  'pack.lotState.HELD': 'रोका गया',
  'pack.lotState.RECALLED': 'वापस मँगाया',
  'pack.lotState.WITHDRAWN': 'बिक्री से हटाया',
  'pack.holdReason.LAB_FAIL': 'लैब नतीजा फ़ेल',
  'pack.holdReason.RUN_MIXED': 'दूसरा बैच मिला',
  'pack.holdReason.LABEL_MISMATCH': 'लेबल जाँच बाकी',
  'pack.holdReason.QUALITY': 'क्वालिटी जाँच',

  'pack.lots.title': 'पैक लॉट',
  'pack.lots.hint': 'क्या इंतज़ार में, रिलीज़ या रोका गया',
  'pack.lots.none': 'इस हॉल में अभी कोई पैक लॉट नहीं।',
  'pack.lots.readyToGo': '{n} रिलीज़ {n:लॉट|लॉट} के पाउच भेजने बाकी हैं।',
  'pack.lots.waitingHint':
    'कार्टन क्वारंटीन एरिया में रखें। क्वालिटी व्यक्ति के रिलीज़ करने तक कुछ बाहर नहीं जाता।',
  'pack.lots.heldHint': 'रोका गया: इसके कार्टन पर “रोका गया” बोर्ड लगाएँ। भेजा नहीं जा सकता।',
  'pack.lots.recalledHint': 'वापस मँगाया: न हिलाएँ, न बेचें। ऑफिस ख़रीदारों को फ़ोन कर रहा है।',

  'pack.run.title': 'पैक रन',
  'pack.run.missing': 'यह पैक रन फ़ोन में नहीं है',
  'pack.run.heldTitle': 'बैच रोका गया',
  'pack.run.heldBodyStarted':
    'भरना रोकें और जितना भरा उसी से रन बंद करें। पाउच रोके गए लॉट में रहेंगे।',
  'pack.run.heldBodyNotStarted': 'बैच रुका है, इसलिए यह रन शुरू नहीं हो सकता।',

  'pack.start.licence': 'हॉल का लाइसेंस',
  'pack.start.licenceBad':
    'हॉल का लाइसेंस नहीं है या ख़त्म हो गया। रन शुरू नहीं हो सकता; ऑफिस से अपडेट करवाएँ।',
  'pack.start.lastCrop': 'इस लाइन पर पिछला रन',
  'pack.start.lastCropUnknown': 'पता नहीं',
  'pack.start.allergen': 'पूरी एलर्जन सफ़ाई हो गई',
  'pack.start.allergenHint': 'इस लाइन पर पिछला रन दूसरी फसल का था।',
  'pack.start.cleanout': 'लाइन और हॉपर खाली और साफ़',
  'pack.start.photo': 'खाली हॉपर की फ़ोटो',
  'pack.start.leftover': 'पिछले रन का बचा माल (किलो)',
  'pack.start.leftoverHint':
    'कुछ नहीं तो 0 लिखें। जो मिले उसे तौलकर साधारण बोरी में अलग रखें, कभी पैक न करें।',
  'pack.start.scaleTitle': 'काँटे की जाँच',
  'pack.start.scaleOverdue': 'कैलिब्रेशन बाकी',
  'pack.start.checkReading': 'जाँच बाट की रीडिंग (ग्राम)',
  'pack.start.checkHint': '{ref} ग्राम का बाट काँटे पर रखें; {tol} ग्राम तक फ़र्क चलेगा।',
  'pack.start.checkOff': 'रीडिंग गलत है। दोबारा जाँचें या दूसरा काँटा लें।',
  'pack.start.label': 'रोल पर लेबल संस्करण',
  'pack.start.noLabel': 'इस हॉल में इस उत्पाद का कोई मंज़ूर लेबल नहीं।',
  'pack.start.labelMatches': 'रोल इन लाइनों से मिलता है',
  'pack.start.labelWrong': 'लाइन पर गलत रोल: शुरू करने से पहले सही रोल लगाएँ।',
  'pack.start.button': 'रन शुरू करें',
  'pack.start.done': 'पैक लॉट {code} बना',
  'pack.start.failed': 'रन शुरू नहीं हुआ',
  'pack.start.needsNetwork': 'रन शुरू करने के लिए नेटवर्क चाहिए: पैक लॉट कोड ऑफिस से आता है।',
  'pack.label.mrp': 'एमआरपी',
  'pack.label.net': 'शुद्ध मात्रा',
  'pack.label.licence': 'एफ़एसएसएआई लाइसेंस',
  'pack.label.allergen': 'एलर्जन लाइन',
  'pack.label.claim': 'दावा',

  'pack.coder.title': 'कोडर में डालें',
  'pack.coder.print': 'प्रिंट',
  'pack.coder.packDate': 'पैक तारीख़',
  'pack.coder.bestBefore': 'इससे पहले उपयोग करें',
  'pack.coder.link': 'क्यूआर लिंक',
  'pack.coder.hint': 'लॉट कोड, तारीख़ें और लिंक बिल्कुल वैसे ही डालें। ये कभी नहीं बदलते।',

  'pack.fill.title': 'भरना और तौलना',
  'pack.fill.sacksTitle': 'हॉपर में बोरियाँ',
  'pack.fill.sacksIn': 'अंदर बोरियाँ',
  'pack.fill.kgIn': 'अंदर किलो',
  'pack.fill.scanSack': 'बोरी स्कैन',
  'pack.fill.machineWeight': 'मशीन पर वज़न',
  'pack.fill.sackWeight': 'बोरी का वज़न (किलो)',
  'pack.fill.sackIn': 'बोरी अंदर',
  'pack.fill.sackSaved': '{tag} अंदर',
  'pack.fill.firstTitle': 'पहला पाउच',
  'pack.fill.firstScan': 'पहला पाउच क्यूआर',
  'pack.fill.firstPhoto': 'पहले पाउच की फ़ोटो',
  'pack.fill.firstNeedsSack': 'पहले एक बोरी तौलकर डालें।',
  'pack.fill.firstOk': 'पहला पाउच लॉट से मिलता है। भराई शुरू हो सकती है।',
  'pack.fill.firstBad':
    'क्यूआर लॉट से नहीं मिलता: कोडर रोकें, लॉट दोबारा डालें और नया पहला पाउच छापें। ख़राब छपाई नष्ट में गिनें।',
  'pack.fill.check': 'पाउच जाँचें',
  'pack.fill.pouchMatch': 'पाउच लॉट से मिलता है',
  'pack.fill.pouchMismatch': 'पाउच लॉट से नहीं मिलता',
  'pack.fill.sackNotPouch': 'यह बोरी का टैग है, पाउच का क्यूआर नहीं',
  'pack.fill.countTitle': 'पाउच',
  'pack.fill.good': 'भरे पाउच',
  'pack.fill.rejected': 'अस्वीकार पाउच',
  'pack.fill.lockedUntilFirst': 'पहला पाउच मिलने के बाद गिनती शुरू होगी।',
  'pack.fill.carton': '+1 कार्टन ({n})',
  'pack.fill.cartonLess': 'एक कार्टन कम',
  'pack.fill.typeCount': 'या गिनती लिखें',
  'pack.fill.reject': '+1 अस्वीकार पाउच',
  'pack.fill.lowPouch': 'न्यूनतम से कम: वह पाउच हॉपर में खाली करें, दोबारा भरें और अस्वीकार गिनें',
  'pack.fill.spotTitle': 'पाउच नंबर {n} तौलें',
  'pack.fill.minWeight': 'न्यूनतम वज़न',
  'pack.fill.spotWeight': 'पाउच का वज़न (ग्राम)',
  'pack.fill.belowMin': 'न्यूनतम वज़न से कम।',
  'pack.fill.next': 'अगला',
  'pack.fill.spotsDone': '{n} पाउच तौले · {low}% कम',
  'pack.fill.stopLineTitle': 'बहुत पाउच कम वज़न के: लाइन रोकें',
  'pack.fill.stopLineBody': 'और भरने से पहले सुपरवाइज़र को बुलाएँ।',
  'pack.fill.lastTitle': 'आख़िरी पाउच',
  'pack.fill.lastScan': 'आख़िरी पाउच क्यूआर',
  'pack.fill.lastPhoto': 'आख़िरी पाउच की फ़ोटो',
  'pack.fill.lastOk': 'आख़िरी पाउच लॉट से मिलता है।',
  'pack.fill.lastBad': 'आख़िरी पाउच लॉट से नहीं मिलता। रन बंद हो सकता है; क्वालिटी व्यक्ति देखेगा।',
  'pack.fill.endTitle': 'बचा माल और गिरा माल',
  'pack.fill.sackType': 'बोरी का प्रकार',
  'pack.fill.leftover': 'हॉपर में बचा माल (किलो)',
  'pack.fill.leftoverTag': 'बचे माल की बोरी',
  'pack.fill.spillage': 'गिरा हुआ माल (किलो)',
  'pack.fill.spillageTag': 'गिरे माल की बोरी',
  'pack.fill.zeroIfNone': 'काँटा जो दिखाए, बोरी समेत; कुछ नहीं तो 0 लिखें',
  'pack.fill.dayOverTitle': 'पैक तारीख़ ख़त्म',
  'pack.fill.dayOverBody': 'अभी भराई पूरी करें। बाकी के लिए नया रन और लॉट चाहिए।',
  'pack.fill.heldFinish': 'बैच रोका गया है: जितना भरा उसी से पूरा करें।',
  'pack.fill.sacksLeft': '{n} जारी {n:बोरी|बोरियाँ} अभी अंदर नहीं: भरना पूरा से पहले तौलकर डालें।',
  'pack.fill.finished': 'भरना पूरा',

  'pack.close.label': 'लेबल संस्करण',
  'pack.close.lotCode': 'पैक लॉट',
  'pack.close.lastMatches': 'आख़िरी पाउच लेबल से मिलता है',
  'pack.close.lastNoMatch':
    'रन समस्या के साथ बंद होगा; क्वालिटी व्यक्ति के सुलझाने तक लॉट रिलीज़ नहीं होगा।',
  'pack.close.pouchCheckGap':
    'पहले या आख़िरी पाउच की जाँच नहीं हुई या नहीं मिली। क्वालिटी व्यक्ति देखेगा।',
  'pack.close.counts': 'कोड',
  'pack.close.applied': 'लगे पाउच',
  'pack.close.printed': 'छपे कोड (कोडर काउंटर)',
  'pack.close.counterPhoto': 'काउंटर की फ़ोटो',
  'pack.close.spoiled': 'ख़राब',
  'pack.close.spoiledHint': 'अस्वीकार या गलत छपे पाउच पर छपे ({n} आज अस्वीकार)',
  'pack.close.destroyed': 'नष्ट',
  'pack.close.destroyedHint': 'छपे पर पाउच नहीं बने: टेस्ट प्रिंट, रोल का अंत',
  'pack.close.reconciliation': 'मिलान',
  'pack.close.addsUp': 'मिलान ठीक',
  'pack.close.gap': '{n} का अंतर',
  'pack.close.recount':
    'कोड दोबारा गिनें। फिर भी न मिले तो रन बंद होगा और लॉट क्वालिटी व्यक्ति का इंतज़ार करेगा।',
  'pack.close.recounted': 'दोबारा गिना, अंतर बाकी',
  'pack.close.weightIn': 'अंदर किलो',
  'pack.close.leftover': 'बचा माल',
  'pack.close.spillage': 'गिरा माल',
  'pack.close.balanceAfterSync': 'वज़न का हिसाब बंद करना सिंक होने पर दिखेगा।',
  'pack.close.done': 'रन बंद हुआ। कार्टन क्वारंटीन एरिया में रखें।',
  'pack.close.backToFill': 'भराई पर वापस',
  'pack.closed.waitingTitle': 'रिलीज़ का इंतज़ार',
  'pack.closed.waitingBody': 'हॉल डेस्क पर कार्टन लेबल छापें और कार्टन क्वारंटीन एरिया में रखें।',
  'pack.closed.released': 'रिलीज़: पाउच भेजे जा सकते हैं।',
  'pack.closed.cartons': 'कार्टन',
  'pack.closed.balance': 'वज़न का हिसाब',
  'pack.closed.packed': 'पैक हुआ',
  'pack.closed.unaccounted': 'बेहिसाब',

  'pack.dispatch.title': 'भेजना',
  'pack.dispatch.hint': 'रिलीज़ पाउच ख़रीदार को भेजें',
  'pack.dispatch.needsNetwork': 'भेजने के लिए नेटवर्क चाहिए: सेव होने तक गाड़ी रुकेगी।',
  'pack.dispatch.buyer': 'ग्राहक',
  'pack.dispatch.invoice': 'बिल या चालान नंबर',
  'pack.dispatch.vehicle': 'गाड़ी नंबर',
  'pack.dispatch.driver': 'ड्राइवर का नाम',
  'pack.dispatch.driverPhone': 'ड्राइवर का फ़ोन',
  'pack.dispatch.phoneBad': '10 अंक',
  'pack.dispatch.clean': 'गाड़ी का फ़र्श खाली और साफ़, कोई रसायन नहीं',
  'pack.dispatch.notClean': 'पहले गाड़ी का फ़र्श साफ़ करें। भेजना सेव नहीं होगा।',
  'pack.dispatch.scan': 'कार्टन लेबल स्कैन करें',
  'pack.dispatch.notCarton': 'कार्टन या पाउच का लेबल नहीं',
  'pack.dispatch.unknownLot': 'पैक लॉट इस हॉल में नहीं',
  'pack.dispatch.already': 'यह लॉट पहले से इस गाड़ी में है',
  'pack.dispatch.refusal.NOT_RELEASED': 'अभी रिलीज़ नहीं',
  'pack.dispatch.refusal.ON_HOLD': 'लॉट रोका गया',
  'pack.dispatch.refusal.TOO_MANY': 'हॉल में सिर्फ़ {n} पाउच बचे',
  'pack.dispatch.refusal.NONE_LEFT': 'हॉल में कोई पाउच नहीं बचा',
  'pack.dispatch.lots': 'पैक लॉट · {n}',
  'pack.dispatch.pouches': 'पाउच',
  'pack.dispatch.total': 'कुल {n} पाउच',
  'pack.dispatch.button': 'भेजें',
  'pack.dispatch.done': 'गाड़ी {code} सेव',
  'pack.dispatch.doneTitle': 'गाड़ी {code} सेव',
  'pack.dispatch.doneBody': '{n} पाउच रास्ते में। ड्राइवर को भेजने की पर्ची और बिल दें।',
  'pack.dispatch.failed': 'भेजना सेव नहीं हुआ',
  'pack.dispatch.printNote': 'भेजने की पर्ची छापें',
  'pack.dispatch.another': 'नई गाड़ी',

  'pack.delabel.title': 'रोके पाउच खाली करें',
  'pack.delabel.list': 'खाली करने के पाउच',
  'pack.delabel.badge': 'साधारण',
  'pack.delabel.pouches': '{n} पाउच',
  'pack.delabel.toEmpty': 'खाली या नष्ट करने के पाउच',
  'pack.delabel.rule':
    'हमारा लेबल कभी दोबारा नहीं लगता: फ़िल्म गिनें और नष्ट करें। हर नई बोरी पर लाल टाई।',
  'pack.delabel.newSack': 'नई साधारण बोरी',
  'pack.delabel.sackSaved': 'बोरी सेव हुई',
  'pack.delabel.counts': 'गिनती',
  'pack.delabel.emptied': 'खाली किए पाउच',
  'pack.delabel.destroyedWhole': 'पूरे नष्ट किए पाउच',
  'pack.delabel.film': 'नष्ट फ़िल्म',
  'pack.delabel.filmHint': 'हर खाली पाउच की एक फ़िल्म',
  'pack.delabel.countGap': '{m} में से {n} पाउच गिने',
  'pack.delabel.done': 'बंद हुआ। ऑफिस निपटान दर्ज करेगा।',
  'pack.delabel.closed': 'यह रन बंद है।',
  // ---- Seva Mandir V1 (features/pack/v1) ----
  'pack.v1.lang': 'hi',
  'pack.v1.help':
    'हर काम की अपनी स्क्रीन है। क्रम से करें: सफ़ाई, शुरू, बोरी, पहला पाउच, भरना, बचा माल, काउंटर। अटके? सुपरवाइज़र को फ़ोन करें।',
  'pack.v1.needsNet': 'नेट चाहिए',
  'pack.v1.next': 'आगे',
  'pack.v1.ok': 'ठीक',
  'pack.v1.save': 'सेव करें',
  'pack.v1.done': 'हो गया',
  'pack.v1.home': 'घर',
  'pack.v1.scan': 'स्कैन',
  'pack.v1.gotIt': 'समझ आ गया',
  'pack.v1.supervisor': 'सुपरवाइज़र',
  'pack.v1.listen': 'सुनें',
  'pack.v1.todo': 'अब करें',
  'pack.v1.groundnut': 'मूंगफली दाना',
  'pack.v1.sizeG': '{g} ग्राम',
  'pack.v1.sizeKg': '{kg} किलो',
  'pack.v1.line': 'लाइन {line}',
  'pack.v1.lineOne': 'लाइन 1',
  'pack.v1.lotTail': 'लॉट …{tail}',
  'pack.v1.lotCode': 'लॉट {code}',
  'pack.v1.batchTail': 'बैच …{tail}',
  'pack.v1.farmerNo': 'किसान नं. {no}',
  'pack.v1.goodLot': 'अच्छा माल · लॉट …{tail}',
  'pack.v1.pouches': '{count} पाउच',
  'pack.v1.pouchUnit': 'पाउच',
  'pack.v1.cartons': '{count} कार्टन',
  'pack.v1.home.title': 'आज: पैकिंग',
  'pack.v1.home.none': 'अभी कोई रन नहीं मिला',
  'pack.v1.home.noneLine': 'ऑफ़िस रन देगा (माल और बैच)। फिर यहाँ दिखेगा।',
  'pack.v1.home.refresh': 'फिर देखें',
  'pack.v1.home.size': '{size} · {pouches} पाउच',
  'pack.v1.home.batch': '{sacks} बोरी · {kg} किलो',
  'pack.v1.home.batchOnly': 'ब्रांड बैच',
  'pack.v1.home.job1': 'लाइन साफ़',
  'pack.v1.home.job1Line': 'हॉपर फोटो',
  'pack.v1.home.job2': 'पैकिंग शुरू',
  'pack.v1.home.job2Line': 'लॉट कोड, तारीख़ें',
  'pack.v1.home.held': 'बैच रुका है: शुरू न करें',
  'pack.v1.home.heldNote': 'यह बैच **रुका** है। शुरू न करें। सुपरवाइज़र से पूछें।',
  'pack.v1.home.noLabel': 'मंज़ूर लेबल नहीं: ऑफ़िस को बताएँ',
  'pack.v1.home.others': 'इसके बाद {count} और रन',
  'pack.v1.clean.title': 'लाइन साफ़ करें',
  'pack.v1.clean.cta': 'लाइन साफ़ करें',
  'pack.v1.clean.lastCrop': 'पिछला रन **{crop}**: **पूरी सफ़ाई**',
  'pack.v1.clean.full': 'पिछला रन दूसरी फ़सल का: **पूरी सफ़ाई**',
  'pack.v1.clean.photo': 'खाली हॉपर',
  'pack.v1.clean.take': 'फोटो लें',
  'pack.v1.clean.again': 'दोबारा',
  'pack.v1.clean.taken': 'ली',
  'pack.v1.clean.hint': 'पिछले रन का कुछ न बचे: हॉपर, बेल्ट, फिलर खाली।',
  'pack.v1.clean.wait': 'हॉपर की फोटो लें',
  'pack.v1.clean.done': 'सफ़ाई हो गई',
  'pack.v1.clean.doneFull': 'पूरी सफ़ाई हो गई',
  'pack.v1.start.cta': 'पैकिंग शुरू करें',
  'pack.v1.start.title': 'पैकिंग शुरू करें?',
  'pack.v1.start.line': '{line} · {sacks} बोरी · {pouches} पाउच',
  'pack.v1.start.cleaned': 'सफ़ाई · हॉपर की फोटो',
  'pack.v1.start.lot': 'LOT {code}',
  'pack.v1.start.dates': 'PKD {pkd} · BB {bb}',
  'pack.v1.start.qr': 'id.uncompromised.in / लॉट',
  'pack.v1.start.locked': 'लॉट कोड, तारीख़ें, QR **फिर नहीं बदलेंगे**',
  'pack.v1.start.yes': 'हाँ, शुरू',
  'pack.v1.start.failed': 'शुरू नहीं हुआ',
  'pack.v1.coder.title': 'कोडर में डालें',
  'pack.v1.coder.started': 'पैकिंग शुरू · {time}',
  'pack.v1.coder.lot': 'लॉट · LOT',
  'pack.v1.coder.packed': 'पैकिंग · PKD',
  'pack.v1.coder.bb': 'इस्तेमाल तक · BB',
  'pack.v1.coder.qr': 'QR',
  'pack.v1.coder.sheet': 'कोडर शीट',
  'pack.v1.coder.done': 'डाल दिया',
  'pack.v1.run.title': 'पैकिंग चालू',
  'pack.v1.run.about': 'लगभग {pouches} पाउच',
  'pack.v1.run.job1': 'बोरी डालें',
  'pack.v1.run.job2': 'पहला पाउच',
  'pack.v1.run.job3': 'पाउच भरें',
  'pack.v1.run.job4': 'बचा माल',
  'pack.v1.run.then': 'फिर: रन बंद',
  'pack.v1.run.thenLine': 'काउंटर का नंबर',
  'pack.v1.run.missing': 'रन इस फ़ोन पर नहीं',
  'pack.v1.run.missingBody': 'वापस जाएँ, नेट से फिर देखें।',
  'pack.v1.sack.title': 'बोरी स्कैन करें',
  'pack.v1.sack.band': 'अच्छा माल · बोरी {n}/{total} · {kg} किलो',
  'pack.v1.sack.saved': 'बोरी {n} · {kg} किलो',
  'pack.v1.sack.hint': 'बोरी का टैग',
  'pack.v1.sack.then': 'स्कैन के बाद **हॉपर** में डालें',
  'pack.v1.sack.wait': 'पहली बोरी स्कैन करें',
  'pack.v1.sack.allIn': 'सब बोरियाँ डलीं',
  'pack.v1.sack.notSack': 'यह बोरी का टैग नहीं: बोरी स्कैन करें',
  'pack.v1.wrong.title': 'बोरी दूसरे बैच की',
  'pack.v1.wrong.s1': 'हॉपर में **न** डालें',
  'pack.v1.wrong.s2': '**गोदाम वाले** को लौटाएँ',
  'pack.v1.wrong.s3': 'डाल दी? तुरंत **सुपरवाइज़र** को फ़ोन',
  'pack.v1.first.title': 'पहला पाउच',
  'pack.v1.first.print': 'कोडर से **पहला पाउच** छापें',
  'pack.v1.first.hint': 'पाउच का QR',
  'pack.v1.first.type': 'पाउच पर लॉट नंबर',
  'pack.v1.first.wont': 'QR नहीं चला',
  'pack.v1.first.wait': 'QR स्कैन करें',
  'pack.v1.first.again': 'फिर स्कैन करें',
  'pack.v1.first.sackTag': 'यह बोरी का टैग है: पाउच का QR स्कैन करें',
  'pack.v1.first.noSack': 'अभी कोई बोरी नहीं डली: पहले बोरी डालें',
  'pack.v1.wont.title': 'QR नहीं चल रहा',
  'pack.v1.wont.why': 'छपाई ख़राब',
  'pack.v1.wont.s1': '**कोडर** रोकें',
  'pack.v1.wont.s2': 'सुपरवाइज़र से **छपाई ठीक** करवाएँ',
  'pack.v1.wont.s3': 'नया पाउच छापें, **स्कैन** करें',
  'pack.v1.wont.cut': 'ख़राब पाउच: काटकर माल **हॉपर में**',
  'pack.v1.mismatch.title': 'QR इस लॉट का नहीं',
  'pack.v1.mismatch.s2': 'कोडर शीट से लॉट **फिर डालें**',
  'pack.v1.mismatch.got': 'पाउच पर',
  'pack.v1.mismatch.want': 'चाहिए',
  'pack.v1.mismatch.cut': 'ग़लत पाउच: काटकर माल **हॉपर में**',
  'pack.v1.fill.title': 'पाउच भरें',
  'pack.v1.fill.filled': 'भरे पाउच',
  'pack.v1.fill.carton': '+1 कार्टन',
  'pack.v1.fill.saved': 'कार्टन {cartons} · {pouches} पाउच',
  'pack.v1.fill.moreSacks': 'और बोरी',
  'pack.v1.fill.type': 'गिनती लिखें',
  'pack.v1.fill.typeTitle': 'कितने पाउच भरे?',
  'pack.v1.fill.undo': 'पिछली ठीक',
  'pack.v1.fill.wait': 'पाउच गिनें',
  'pack.v1.fill.done': 'भरना पूरा',
  'pack.v1.left.title': 'बचा माल',
  'pack.v1.left.band': 'अच्छा माल · नई बोरी',
  'pack.v1.left.label': 'कितना बचा? नहीं तो 0',
  'pack.v1.left.speak': '{kg} किलो',
  'pack.v1.left.tag': 'नई बोरी का टैग',
  'pack.v1.left.wait': 'वज़न लिखें, या 0',
  'pack.v1.left.needTag': 'नई बोरी का टैग स्कैन करें',
  'pack.v1.left.noSack': 'इस फ़ोन पर बोरी का प्रकार नहीं',
  'pack.v1.left.saved': 'बची बोरी · {kg} किलो',
  'pack.v1.left.none': 'नहीं',
  'pack.v1.left.noneSaved': 'बचा माल नहीं',
  'pack.v1.counter.title': 'कोडर का काउंटर',
  'pack.v1.counter.ask': 'काउंटर पर कौन सा नंबर?',
  'pack.v1.counter.label': 'काउंटर',
  'pack.v1.counter.pouches': '{count} पाउच भरे · {cartons} कार्टन',
  'pack.v1.counter.spoiled': 'ख़राब छपे कोड',
  'pack.v1.counter.spoiledHint': 'छपे पर अच्छे पाउच पर नहीं (अटके, ग़लत छपे, फटे)',
  'pack.v1.counter.wait': 'काउंटर का नंबर लिखें',
  'pack.v1.close.cta': 'रन बंद करें',
  'pack.v1.close.title': 'रन बंद करें?',
  'pack.v1.close.locked': 'बंद के बाद **कुछ नहीं जुड़ेगा**',
  'pack.v1.close.yes': 'हाँ, बंद करें',
  'pack.v1.close.overfill':
    'डाले से ज़्यादा निकला: {in} किलो बोरियों से {out} किलो पाउच और बचा माल। पाउच की गिनती जाँचें।',
  'pack.v1.close.fixCount': 'पाउच की गिनती ठीक करें',
  'pack.v1.closed.title': 'रन बंद',
  'pack.v1.closed.line': '{pouches} पाउच · {cartons} कार्टन',
  'pack.v1.closed.s1': 'कार्टन **हॉल में** अलग रखें',
  'pack.v1.closed.s2': 'ऑफ़िस की **मंज़ूरी** के बाद ही भेजना',
  'pack.v1.stop.title': 'रुकिए: बैच रोका',
  'pack.v1.stop.big': 'भरना अभी रोकें',
  'pack.v1.stop.why': 'बैच …{tail} · {reason}',
  'pack.v1.stop.lab': 'लैब जाँच',
  'pack.v1.stop.office': 'ऑफ़िस ने रोका',
  'pack.v1.stop.s1': '**कोडर** रोकें',
  'pack.v1.stop.s2': 'भरे पाउच गिनकर **रन बंद**',
  'pack.v1.stop.s3': 'कार्टन **रुके माल** की जगह',
  'pack.v1.hall.title': 'पैकिंग हॉल',
  'pack.v1.hall.atHall': 'हॉल में पाउच',
  'pack.v1.hall.released': 'मंज़ूर',
  'pack.v1.hall.waiting': 'मंज़ूरी बाकी',
  'pack.v1.hall.held': 'रुके',
  'pack.v1.hall.canGo': 'भेज सकते हैं',
  'pack.v1.hall.noneReady': 'अभी कोई लॉट मंज़ूर नहीं',
  'pack.v1.hall.noneReadyLine': 'ऑफ़िस की मंज़ूरी के बाद ही लॉट जाता है।',
  'pack.v1.hall.dispatch': 'माल भेजें',
  'pack.v1.hall.receive': 'गाड़ी आई? माल उतारें',
  'pack.v1.hall.receiveLine': 'प्रोसेसिंग से आए बैच',
  'pack.v1.buyer.title': 'किसे भेजना है?',
  'pack.v1.buyer.wait': 'ख़रीदार चुनें',
  'pack.v1.buyer.none': 'इस फ़ोन पर कोई ख़रीदार नहीं। ऑफ़िस से पूछें।',
  'pack.v1.invoice.title': 'इनवॉइस नंबर',
  'pack.v1.invoice.label': 'इनवॉइस नंबर (आख़िरी 4)',
  'pack.v1.invoice.wait': 'इनवॉइस नंबर लिखें',
  'pack.v1.lots.title': 'कितने पाउच?',
  'pack.v1.lots.left': 'हॉल में {count}',
  'pack.v1.lots.wait': 'किसी लॉट के पाउच लिखें',
  'pack.v1.lots.over': 'लॉट …{tail}: हॉल में सिर्फ़ {left}',
  'pack.v1.trip.title': 'माल रवाना करें?',
  'pack.v1.trip.line': 'इनवॉइस {invoice} · {count} पाउच',
  'pack.v1.trip.locked': 'रवाना के बाद पाउच **हटा या जोड़ नहीं** सकते',
  'pack.v1.trip.yes': 'हाँ, रवाना',
  'pack.v1.sent.title': 'माल रवाना',
  'pack.v1.sent.line': '{buyer} · इनवॉइस {invoice}',
  'pack.v1.sent.s1': '**इनवॉइस** माल के साथ भेजें',
  'pack.v1.sent.failed': 'रवाना नहीं हुआ',
  'pack.v1.error.ALLERGEN_CLEAN_MISSING': 'पिछला रन दूसरी फ़सल का: पूरी सफ़ाई करें, नई फोटो लें',
  'pack.v1.error.SCALE_CHECK_FAILED': 'सर्वर काँटे की जाँच माँग रहा है: ऑफ़िस को फ़ोन करें',
  'pack.v1.error.LINE_BUSY': 'इस लाइन पर दूसरा रन चालू है',
  'pack.v1.error.RUN_ALREADY_STARTED': 'यह रन पहले ही शुरू है',
  'pack.v1.error.LABEL_VERSION_MISMATCH': 'लेबल इस हॉल के लिए मंज़ूर नहीं: ऑफ़िस को बताएँ',
  'pack.v1.error.PREMISES_LICENCE_MISSING': 'हॉल का FSSAI लाइसेंस नहीं: ऑफ़िस को बताएँ',
  'pack.v1.error.BATCH_NOT_PACKABLE': 'बैच अभी पैक नहीं हो सकता: ऑफ़िस से पूछें',
  'pack.v1.error.CLEANOUT_MISSING': 'हॉपर की फोटो नहीं',
  'pack.v1.error.NOT_A_BUYER': 'यह ख़रीदार दर्ज नहीं',
  'pack.v1.error.LOT_NOT_RELEASED': 'कोई लॉट मंज़ूर नहीं या रुका है',
  'pack.v1.error.OVER_DISPATCHED': 'हॉल में बचे से ज़्यादा पाउच',
  'pack.v1.error.UNKNOWN_PACK_LOT': 'लॉट नहीं मिला',
  'pack.v1.error.VEHICLE_NOT_CLEAN': 'सर्वर गाड़ी की जाँच माँग रहा है: ऑफ़िस को फ़ोन करें',
}
